import { render, staticRenderFns } from "./CeldaSwitch.vue?vue&type=template&id=3e9d8d38&scoped=true&"
import script from "./CeldaSwitch.vue?vue&type=script&lang=js&"
export * from "./CeldaSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9d8d38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VRadioGroup,VSwitch})
